module.exports = __webpack_public_path__ + "static/media/8_weblink-WelzijnonzeZorg.7e478369.png";